// extracted by mini-css-extract-plugin
export default {"withTail":"rNM7m9","direction-left":"IB19_s","direction-right":"XEJhuy"};